import { useRouteMatch } from 'react-router';
import { useTranslation } from 'react-i18next';
import ErrorResponse from '../../../../components/ErrorResponse';
import Loader from '../../../../components/Loader';
import SimpleHeader from '../../../../components/layout/SimpleHeader';
import SpeakingTestPartEditor from '../../../../components/cbt/speaking-test/part/Editor';
import useNotification from '../../../../hooks/useNotification';
import useAxios from '../../../../hooks/useAxios';
import { useEffect, useState } from 'react';
import {
  IGetSpeaking,
  IGetSpeakingPaper,
} from '../../../../models/newSpeaking.model';
import {
  getSpeaking,
  getSpeakingPaper,
  putSpeakingPaper,
} from '../../../../api/newSpeaking.api';
import { getDetailCode, getDetailCodeLabel } from '../../../../lib/util';
import { useSelector } from 'react-redux';
import { RootState } from '../../../../store/rootReducer';

interface IMatch {
  id: string;
  subid: string;
}

const CbtSpeakingTestPartEdit = () => {
  const { t } = useTranslation();
  const match = useRouteMatch<IMatch>();
  const speakingExamCode = +match.params.id;
  const speakingPartCode = String(match.params.subid);
  const { successNotification } = useNotification();
  const {
    data: res,
    isLoading,
    error,
    execute,
  } = useAxios<IGetSpeakingPaper>();
  const {
    data: updateRes,
    isLoading: updateIsLoading,
    error: updateError,
    execute: updateExecute,
  } = useAxios<IGetSpeakingPaper>();
  const {
    data: res2,
    isLoading: isLoading2,
    error: error2,
    execute: execute2,
  } = useAxios<IGetSpeaking>();
  const { commonCodes } = useSelector((state: RootState) => state.commonCode);

  const [title, setTitle] = useState('');

  const TE0008 = getDetailCode(commonCodes, 'TE0008');
  const TE0003 = getDetailCode(commonCodes, 'TE0003');

  useEffect(() => {
    execute(getSpeakingPaper({ speakingPartCode, speakingExamCode }));
    execute2(getSpeaking(speakingExamCode));
  }, []);

  useEffect(() => {
    if (updateRes && !updateIsLoading) {
      execute(getSpeakingPaper({ speakingPartCode, speakingExamCode }));
      successNotification(t('common.message.save1'));
    }
  }, [updateRes, updateIsLoading]);

  useEffect(() => {
    if (res2?.data) {
      setTitle(
        `${getDetailCodeLabel(
          TE0008,
          res2.data.examType,
        )} / ${getDetailCodeLabel(TE0003, res2.data.speakingExamType)}`,
      );
    }
  }, [res2]);

  const onSubmit = (form: FormData) => {
    if (!updateIsLoading) updateExecute(putSpeakingPaper(form));
  };

  return (
    <div className="content scrollbar">
      {(isLoading || isLoading2 || updateIsLoading) && <Loader />}
      <ErrorResponse error={error} />
      <ErrorResponse error={error2} />
      <ErrorResponse error={updateError} />
      <SimpleHeader parentMenu={t('common.menu.cbt')} currentMenu={t('cbt.speakTest.title4')} onlyTitle />
      <div>
        <SpeakingTestPartEditor
          title={title}
          data={res?.data}
          speakingExamCode={String(speakingExamCode)}
          speakingPartCode={speakingPartCode}
          submit={onSubmit}
        />
      </div>
    </div>
  );
};

export default CbtSpeakingTestPartEdit;
